<page-load-header *ngIf="!initialized"></page-load-header>

<div [hidden]="!initialized || !hasData" class="chart-container">
  <div id="speedChart"></div>
</div>

